"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddToForwardRef = exports.setRefs = void 0;
const react_1 = require("react");
function setRefs(refs, ele) {
    refs.filter((ref) => ref !== undefined && ref !== null).forEach((ref) => {
        if (ref instanceof Function) {
            ref === null || ref === void 0 ? void 0 : ref(ele);
        }
        else {
            ref.current = ele;
        }
    });
}
exports.setRefs = setRefs;
function useAddToForwardRef(props, refs) {
    const forwardedRefFromProps = props.forwardedRef;
    return react_1.useCallback((ele) => {
        refs.filter((ref) => ref !== undefined && ref !== null).forEach((ref) => {
            if (ref instanceof Function) {
                ref === null || ref === void 0 ? void 0 : ref(ele);
            }
            else {
                ref.current = ele;
            }
        });
        forwardedRefFromProps === null || forwardedRefFromProps === void 0 ? void 0 : forwardedRefFromProps(ele);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...refs, forwardedRefFromProps]);
}
exports.useAddToForwardRef = useAddToForwardRef;
